/* eslint-disable import/prefer-default-export */
import React from 'react'

export const CloseIcon = ({ className }) => (
  <svg
    className={className}
    fill="none"
    height="40"
    viewBox="0 0 40 40"
    width="40"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line
      stroke="black"
      strokeLinecap="round"
      x1="37"
      x2="2.35177"
      y1="2.70711"
      y2="37.3553"
    />
    <line
      stroke="black"
      strokeLinecap="round"
      x1="2.35176"
      x2="37"
      y1="2"
      y2="36.6482"
    />
  </svg>
)
